<template>
  <card-seplag titulo="Cronograma de Férias">
    <div class="p-col-12">
      <div class="p-grid p-align-end p-justify-start">
        <!-- Campo Data Inicial -->
        <Rotulo nome="Data inicial" cols="12 2">
          <v-date-picker
            v-model="data_inicio"
            :max-date="max_date"
            :min-date="min_date"
            :model-config="datePikerConfig"
            :first-day-of-week="1"
            :update-on-input="false"
            :masks="datePikermasks"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="p-inputmask p-inputtext p-component"
                :value="inputValue"
                v-on="inputEvents"
              />
            </template>
          </v-date-picker>
        </Rotulo>

        <!-- Campo Data Final -->
        <Rotulo nome="Data final" cols="12 2">
          <v-date-picker
            v-model="data_fim"
            :max-date="max_date"
            :min-date="min_date"
            :model-config="datePikerConfig"
            :first-day-of-week="1"
            :update-on-input="false"
            :masks="datePikermasks"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="p-inputmask p-inputtext p-component"
                :value="inputValue"
                v-on="inputEvents"
              />
            </template>
          </v-date-picker>
        </Rotulo>
        <div class="p-md-2 p-col-12">
          <Button
            label="Buscar"
            icon="pi pi-search"
            class="p-button-info"
            @click="validarDatas()"
          />
        </div>
      </div>
      <div class="p-grid p-col-12" style="margin-top:10px;">
        <Rotulo cols="12 3" nome="Setor:">
            <Dropdown v-model="unidadeSelecionada" :options="listaUnidades" optionLabel="labelDropDaw"
                placeholder="Selecione..." filter :disabled="false" @change = "validarDatas()" />                
        </Rotulo>
      </div>
    </div>

    <!-- Tabela Dinâmica -->
    <div class="tabela-container">
      <table class="tabela-cronograma">
        <tr>
          <th rowspan="3" class="servidores no-border col-fixed">Servidores</th>
          <td
            class=""
            v-for="(mes, index) in diasMes"
            :key="index"
            :colspan="mes.colspan"
          >
            {{ mes.mes }}
          </td>
        </tr>
        <tr>
          <td v-for="(dia, index) in todosDias" :key="'dia-' + index">
            {{ retornaDia(dia) }}
          </td>
        </tr>
        <tr>
          <td v-for="(dia, index) in todosDias" :key="'percent' + index">
            {{ percentPresenca(dia.data) }}%
          </td>
        </tr>
        <!-- Linhas de Servidores -->
        <tr v-for="servidor in servidoresIn" :key="servidor.nomeServidor">
          <th class="clicavel col-fixed" @click="clicouServidor(servidor)">
            {{ servidor.nomeServidor }}
          </th>
          <td
            v-for="(data, index) in todosDias"
            :key="'servidorIn-' + index"
            :class="'status-' + getLayout(servidor, data.data)"
            @click="mostrarModal(servidor, data.data)"
          ></td>
        </tr>
        <tr v-for="servidor in servidoresOut" :key="servidor.nomeServidor">
          <th
            class="clicavel no-border col-removed"
            @click="clicouServidor(servidor)"
          >
            {{ servidor.nomeServidor }}
          </th>
          <td v-for="(data, index) in todosDias" :key="'servidorOut-' + index">
            &nbsp; &nbsp;
          </td>
        </tr>
      </table>
    </div>

    <!-- MODAL DE VALIDAÇÃO -->
    <cadastro-rapido
      v-if="true"
      :tituloTela="'Aprovação'"
      v-model="exibirModal"
      :modoEdicao="'adicionar'"
      :onAdicionar="salvar"
      optionValue="code"
      :textoButton="'Salvar'"
    >
      <div class="p-col-12">
        <Fieldset>
          <template #legend>
            <strong>Servidor</strong>
          </template>
          <p>
            <strong>Matricula: </strong>
            {{ this.servidorAnalise.matricula }}
          </p>
          <p>
            <strong>Candidato: </strong>
            {{ this.servidorAnalise.nomeServidor }}
          </p>
          <p>
            <strong>Período de Usufruto: </strong>
            {{
              this.servidorAnalise.dataInicioPeraq +
              " à " +
              this.servidorAnalise.dataFimPeraq
            }}
          </p>
        </Fieldset>
      </div>
      <Rotulo nome="Deferido" cols="12">
        <SelectButton
          name="deferido"
          v-model="registro.statusProgramacao"
          :options="simNao"
          optionLabel="name"
          v-required
        />
      </Rotulo>
      <Rotulo nome="Justificativa" cols="12">
        <Textarea v-model="registro.observacaoTemporaria" rows="5" cols="30" />
      </Rotulo>
    </cadastro-rapido>
  </card-seplag>
</template>

<script>
// Importa o componente CardSeplag
import CardSeplag from "@/template/CardSeplag.vue";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import moment from "moment";
import { baseApiUrl } from "@/config/global";
import { simNao } from "@/config/global";

const getDefaultState = () => {
  return {
    observacaoTemporaria: "",
    statusProgramacao: { name: "Não", code: "N" },
  };
};

export default {
  name: "CronogramaFerias", // Nome do componente atual
  components: {
    CardSeplag,
    Rotulo,
    CadastroRapido, // Registra o componente CardSeplag
  },
  data() {
    return {
      data_inicio: moment().startOf("month").format("DD/MM/YYYY"),
      data_fim: moment().endOf("month").format("DD/MM/YYYY"),
      max_date: null,
      min_date: null,
      datePikerConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },
      datePikermasks: {
        input: "DD/MM/YYYY",
      },
      servidores: [], // Servidores retornados pela API
      diasMes: this.gerarDadosTabela(), // Dias do mês a serem mostrados na tabela
      todosDias: [],
      servidoresIn: [], //lista servidores selecionados
      servidoresOut: [], //lista servidores não selecionados
      todosServidoresFerias: [],
      totalServidoresSetor: null,
      exibirModal: false,
      servidorAnalise: {},
      simNao: simNao,
      registro: getDefaultState(),    

      listaUnidades: null,
      unidadeSelecionada: null
    };
  },
  methods: {
    //bloco inicial, carregar dados
    gerarDadosTabela() {
      let startDate = moment(this.data_inicio, "DD/MM/YYYY");
      let endDate = moment(this.data_fim, "DD/MM/YYYY");
      let daysMonths = [];
      let currentMonth = null;
      let days = [];
      this.todosDias = [];

      // Loop enquanto a data inicial for menor ou igual a data final
      while (startDate <= endDate) {
        let month = startDate.format("MMM/YY");
        // Calcular o último dia do mês atual
        let lastDayOfMonth = startDate.clone().endOf("month");

        if (currentMonth !== month) {
          days = [];
          while (startDate <= lastDayOfMonth && startDate <= endDate) {
            days.push({
              dia: startDate.format("DD"),
            });
            this.todosDias.push({
              data: startDate.format("DD/MM/YYYY"),
            });
            startDate.add(1, "days");
          }
          // Adiciona o mês e os dias no array
          daysMonths.push({
            mes: month,
            colspan: days.length,
          });
          currentMonth = month;
        }
      }
      return daysMonths;
    },
    async atualizarData() {
      this.servidoresIn = [];
      this.servidoresOut = [];
      let bodyRequest = {
        numFunc: parseInt(this.$store.getters.getMatricula),
        numVinc: parseInt(this.$store.getters.getVinculo),
        dataInicio: moment(this.data_inicio, "DD/MM/YYYY").format("YYYY-MM-DD"),
        dataFim: moment(this.data_fim, "DD/MM/YYYY").format("YYYY-MM-DD"),
      };
      await this.$http
        .post(
          `${baseApiUrl}/feriasview/cronogramaSetor/${this.unidadeSelecionada.codgSeap}`,
          JSON.stringify(bodyRequest)
        )
        .then((response) => {
          this.servidoresOut = response.data.listaServidores;
          this.todosServidoresFerias = response.data.listaServidores;
          this.totalServidoresSetor = response.data.totalServidoresSetor;
          this.diasMes = this.gerarDadosTabela(); // Recalcula os dias se houver alteração
          this.$toast.add({
            severity: "success",
            summary: "Dados na tela.",
            life: 3000,
          });
        });
    },
    validarDatas() {
      let startDate = moment(this.data_inicio, "DD/MM/YYYY");
      let endDate = moment(this.data_fim, "DD/MM/YYYY");

      if (startDate > endDate) {
        this.$toast.add({
          severity: "error",
          summary: "Datas inválidas",
          life: 3000,
        });
      } else {
        this.atualizarData();
      }
    },
    //fim bloco inicial

    //bloco de ordenacao dos servidores
    formatDate(dateString) {
      const parts = dateString.split("/"); // Divide a data "12/03/2025" em ["12", "03", "2025"]
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // Retorna no formato "2025-03-12"
    },
    menorTemporariaOuData(data) {
      if (data.dataInicioTemporaria !== null) {
        let inicioTemporaria = new Date(
          this.formatDate(data.dataInicioTemporaria)
        );
        let inicio = new Date(this.formatDate(data.dataInicio));

        // Compara as duas datas: se a data temporária for anterior à data de início
        if (inicioTemporaria < inicio) {
          return data.dataInicioTemporaria;
        }
        // return data.dataInicio;
      } else {
        return data.dataInicio;
      }
    },
    ordenar() {
      this.servidoresIn.sort((a, b) => {
        // Primeiro, ordena os períodos de férias dentro de cada servidor
        a.datas.sort((alfa, beta) => {
          let menorDataA = this.menorTemporariaOuData(alfa);
          let menorDataB = this.menorTemporariaOuData(beta);
          return (
            new Date(this.formatDate(menorDataA)) -
            new Date(this.formatDate(menorDataB))
          ); // Comparando as datas
        });
        b.datas.sort((alfa, beta) => {
          let menorDataA = this.menorTemporariaOuData(alfa);
          let menorDataB = this.menorTemporariaOuData(beta);
          return (
            new Date(this.formatDate(menorDataA)) -
            new Date(this.formatDate(menorDataB))
          ); // Comparando as datas
        });

        const dataInicioA = new Date(
          this.formatDate(this.menorTemporariaOuData(a.datas[0]))
        );
        const dataInicioB = new Date(
          this.formatDate(this.menorTemporariaOuData(b.datas[0]))
        );

        // Primeiro critério: ordenar por dataInicio (mais próxima)
        if (dataInicioA.getTime() !== dataInicioB.getTime()) {
          return dataInicioA - dataInicioB;
        }

        // Segundo critério: caso as datas sejam iguais, ordenar por nomeServidor
        return a.nomeServidor.localeCompare(b.nomeServidor);
      });
      this.servidoresOut.sort((a, b) => {
        return a.nomeServidor.localeCompare(b.nomeServidor);
      });
    },
    //fim do bloco de ordenacao

    //bloco metodos tabela
    //preenche data primeira linha da tabela
    retornaDia(dia) {
      let data = moment(dia.data, "DD/MM/YYYY").format("DD");
      return data;
    },

    //preenche percentual de presenca
    percentPresenca(dia) {
      let totalServidoresFerias = 0;
      // Corrigido a formatação da data e usamos some para verificar todas as datas de férias
      this.todosServidoresFerias.forEach((servidor) => {
        // Verifica se alguma das datas de férias corresponde ao dia
        const isOnVacation = servidor.datas.some((data) => {
          let startDate = moment(data.dataInicio, "DD/MM/YYYY");
          let endDate = moment(data.dataFim, "DD/MM/YYYY");
          return moment(dia, "DD/MM/YYYY").isBetween(
            startDate,
            endDate,
            null,
            "[]"
          );
        });

        // Se o servidor estiver de férias, incrementa o contador
        if (isOnVacation) {
          totalServidoresFerias++;
        }
      });
      let percent =
        (1 - totalServidoresFerias / this.totalServidoresSetor) * 100;

      // Arredondar para duas casas decimais
      //return percent.toFixed(2);

      // Arredondar para um número inteiro sem casas decimais
      return Math.round(percent);
    },
    //controle layout data ferias
    isFerias(servidor, dia) {
      let status = new Set();
      servidor.datas.find((data) => {
        let dataInicioTemporaria = null;
        let dataFimTemporaria = null;
        let dataInicio = moment(data.dataInicio, "DD/MM/YYYY");
        let dataFim = moment(data.dataFim, "DD/MM/YYYY");
        if (
          data.dataInicioTemporaria !== null &&
          data.dataFimTemporaria !== null
        ) {
          dataInicioTemporaria = moment(
            data.dataInicioTemporaria,
            "DD/MM/YYYY"
          );
          dataFimTemporaria = moment(data.dataFimTemporaria, "DD/MM/YYYY");
          if (
            moment(dia, "DD/MM/YYYY").isBetween(
              dataInicioTemporaria,
              dataFimTemporaria,
              null,
              "[]"
            )
          ) {
            status.add("PENDENTE");
          }
        }
        if (
          moment(dia, "DD/MM/YYYY").isBetween(dataInicio, dataFim, null, "[]")
        ) {
          status.add(data.statusFerias);
        }
      });
      return status;
    },
    getLayout(servidor, dia) {
      let status = this.isFerias(servidor, dia);

      // Verificando o tamanho do Set usando .size
      if (status.size > 1) {
        //console.log("aqui");
        return "AprovadoPendente"; // Se houver mais de um status, retorna "AprovadoPendente"
      } else {
        // Convertendo Set para array e pegando o primeiro valor, se houver
        return [...status][0] || null; // Se o Set não estiver vazio, retorna o primeiro valor, caso contrário retorna null
      }
    },

    //controle modal aprovacao
    abrirModalAprovacao() {
      this.exibirModal = true;
    },
    carregarServidor(servidor, data) {
      const periodo = servidor.datas.find((ferias) => {
        let startDate = moment(ferias.dataInicioTemporaria, "DD/MM/YYYY");
        let endDate = moment(ferias.dataFimTemporaria, "DD/MM/YYYY");
        return moment(data, "DD/MM/YYYY").isBetween(
          startDate,
          endDate,
          null,
          "[]"
        );
      });
      let startDate = moment(periodo.dataInicio, "DD/MM/YYYY");
      let endDate = moment(periodo.dataFim, "DD/MM/YYYY");
      this.servidorAnalise.nomeServidor = servidor.nomeServidor;
      this.servidorAnalise.chave = periodo.chave;
      this.servidorAnalise.dataFim = periodo.dataFim;
      this.servidorAnalise.dataInicio = periodo.dataInicio;
      this.servidorAnalise.idReg = periodo.idReg;
      this.servidorAnalise.matricula = servidor.numFunc;
      this.servidorAnalise.numeroVinculo = servidor.numVinc;
      this.servidorAnalise.observacaoTemporaria = null;
      this.servidorAnalise.qtdDiasAfastamento =
        endDate.diff(startDate, "days") + 1; // Usa diff para obter a diferença em dias
      this.servidorAnalise.dataInicioPeraq = periodo.dataInicioPeraq;
      this.servidorAnalise.dataFimPeraq = periodo.dataFimPeraq;
    },
    mostrarModal(servidor, data) {
      let status = this.isFerias(servidor, data);
      if (status.has("PENDENTE")) {
        this.carregarServidor(servidor, data);
        this.abrirModalAprovacao();
      } else {
        this.$toast.add({
          severity: "info",
          summary: "Não passível de aprovação",
          life: 3000,
        });
      }
    },
    //fim modal

    //controle coluna servidor
    clicouServidor(servidor) {
      if (this.servidoresOut.includes(servidor)) {
        this.servidoresIn.push(servidor);
        // Remove servidor from servidoresOut
        this.servidoresOut = this.servidoresOut.filter(
          (item) => item !== servidor
        );
      } else {
        this.servidoresOut.push(servidor);
        // Remove servidor from servidoresIn
        this.servidoresIn = this.servidoresIn.filter(
          (item) => item !== servidor
        );
      }
      this.ordenar();
    },

    //bloco salvar
    atualizar(situacao) {
      this.servidoresIn.forEach((servidor) => {
        if (servidor.numFunc === this.servidorAnalise.matricula) {
          if (situacao == "REPROVADO") {
            servidor.datas.forEach((data) => {
              if (data.dataInicio === this.servidorAnalise.dataInicio) {
                data.dataInicioTemporaria = null;
                data.dataFimTemporaria = null;
              }
            });
          } else {
            servidor.datas.forEach((data) => {
              if (data.dataInicio === this.servidorAnalise.dataInicio) {
                data.dataInicio = data.dataInicioTemporaria;
                data.dataFim = data.dataFimTemporaria;
                data.dataInicioTemporaria = null;
                data.dataFimTemporaria = null;
                data.statusFerias = "APROVADO";
              }
            });
          }
        }
      });
    },
    salvar() {
      if (
        this.registro.statusProgramacao.code == "N" &&
        this.registro.observacaoTemporaria.trim() == ""
      ) {
        this.$toast.add({
          severity: "error",
          summary:
            "A justificativa é OBRIGATORIA quando o pedido de Férias for negado",
          life: 3000,
        });
        return;
      } else {
        this.servidorAnalise.observacaoTemporaria =
          this.registro.observacaoTemporaria;
        let situacao = "";
        if (this.registro.statusProgramacao.code == "S") {
          situacao = "APROVADO";
        } else {
          situacao = "REPROVADO";
        }
        let jsonBody = {
          ...this.servidorAnalise,
          matriculaAprovador: this.$store.getters.getMatricula,
          numeroVinculoAprovador: this.$store.getters.getVinculo,
        };
        this.$http
          .put(
            `${baseApiUrl}/feriasview/chefia/acao/${situacao}`,
            JSON.stringify(jsonBody)
          )
          .then(() => {
            if (this.registro.statusProgramacao.code == "S") {
              this.$toast.add({
                severity: "success",
                summary:
                  "Agendamento aprovado com Sucesso! Informações encaminhadas por email",
                life: 3000,
              });
            }
            this.atualizar(situacao);
            this.exibirModal = false;
          });
      }
    },
    //fim bloco salvar
    //bloco metodos tabela

    async buscaUnidades(){
      const matricula = this.$store.getters.getMatricula
      const vinculo = this.$store.getters.getVinculo

      await this.$http.get(`${baseApiUrl}/lincencaview/chefia/hierarquiaUnidades/${matricula}/${vinculo}`).then(respUnidades => {                    
            this.listaUnidades = respUnidades.data.map(function (element) {
                return {
                    ...element,
                    labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
                };
            });
            
        })

      this.unidadeSelecionada = this.unidadeSelecionada ? this.unidadeSelecionada : this.listaUnidades[0]

    },
  },
  mounted() {    
    this.buscaUnidades();
  },
};
</script>

<style scoped>
.tabela-container {
  width: 100%;
  overflow-x: auto;
  /* Permite o scroll horizontal */
  -webkit-overflow-scrolling: touch;
  /* Suporte para scroll suave em dispositivos móveis */
}

.tabela-cronograma {
  width: 100%;
  border-collapse: collapse;
  /* Ajusta a largura das colunas de acordo com o conteúdo */
  table-layout: auto;
  /* Permite que o texto não quebre e a largura da coluna se ajuste ao conteúdo */
  white-space: nowrap;
}

.servidores {
  border-top-left-radius: 5px;
}

.clicavel {
  cursor: pointer;
}

th {
  padding: 10px;
  text-align: center;
}

td {
  font-size: smaller;
  border: 1px solid black;
  padding: 10px;
  text-align: center;
  /* Remove o min-width para ajustar a largura das colunas ao conteúdo */
  min-width: 0;
  border-color: #a0a0a0;
  color: #a0a0a0;
}

.no-border {
  border: 0px;
}

.col-fixed {
  font-weight: bold;
  position: sticky;
  left: 0;
  background-color: #a0a0a0;
  /* Fundo branco para que a coluna fixa fique visível */
  z-index: 3;
  /* Garante que a coluna de servidores fique por cima das outras células */
  min-width: 200px;
  /* Define uma largura mínima para a coluna de servidores */
}

.col-removed {
  font-weight: lighter;
  color: #fff;
  left: 0;
  position: sticky;
  background-color: #c0c0c0;
}

.status-APROVADO {
  background-color: #c8e6c9;
  color: #256029;
}

.status-FINALIZADO {
  background-color: #b3e5fc;
  color: #23547b;
}

.status-AprovadoPendente {
  background: linear-gradient(45deg, #c8e6c9, #feedaf);
  color: #256029;
  cursor: pointer;
}

.status-PENDENTE {
  background-color: #feedaf;
  color: #8a5340;
  cursor: pointer;
}
</style>
